// $(document).ready(function() {
//   $('.menu_item-link .reversed-links').each(function() {
//     var text = $(this).text();
//     var updated = text.replace(/\(([^)]+)\)/, '<span class="menu-span">$1</span>');
//     $(this).html(updated);
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.menu_item-link .reversed-links').forEach(function (el) {
    var text = el.textContent;
    var match = text.match(/\(([^)]+)\)/);
    if (match) {
      var replaced = text.replace(/\(([^)]+)\)/, '<span class="menu-span">' + match[1] + '</span>');
      el.innerHTML = replaced;
    }
  });
});

  document.addEventListener("DOMContentLoaded", function () {
    const link = document.querySelector('a[href="https://alchemist.ae"]');
    if (link) {
      link.target = '_blank';
      link.rel = 'noreferrer noopener';
    }
  });


document.addEventListener("DOMContentLoaded", function () {
  const btn1 = document.querySelector('.btn1');
  const otherButtons = document.querySelectorAll('.btn2, .btn3, .btn4');

  // Hover effects for other buttons
  otherButtons.forEach(btn => {
    btn.addEventListener('mouseenter', () => {
      btn1.style.background = 'transparent';
      btn1.style.color = '#b1b1b1';
      btn1.style.border = '1px solid transparent';
    });
    btn.addEventListener('mouseleave', () => {
      btn1.style.background = '#fff';
      btn1.style.color = '#000';
      btn1.style.border = '1px solid #fff';
    });
  });

  // Hover effects for btn1
  btn1.addEventListener('mouseenter', () => {
    btn1.style.background = '#957a63';
    btn1.style.color = '#fff';
    btn1.style.border = '1px solid #957a63';
  });

  btn1.addEventListener('mouseleave', () => {
    btn1.style.background = '#fff';
    btn1.style.color = '#000';
    btn1.style.border = '1px solid #fff';
  });
});


// document.addEventListener("DOMContentLoaded", function () {
//   const btn1 = document.querySelector('.btn1');
//   const otherButtons = document.querySelectorAll('.btn2, .btn3, .btn4');

//   otherButtons.forEach(btn => {
//     btn.addEventListener('mouseenter', () => {
//       btn1.style.background = 'transparent';
//       btn1.style.color = '#b1b1b1';
//       btn1.style.border = '1px solid transparent';
//     });
//     btn.addEventListener('mouseleave', () => {
//       btn1.style.background = '#fff';
//       btn1.style.color = '#000';
//       btn1.style.border = '1px solid #fff';
//     });
//   });
// });